import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../redux/auth/auth";
import AccessibilityMenu from "../../components/AccessibilityMenu";
import { useTheme } from "../../utils/theme";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";
import { V1_API_ORIGIN } from "../../config/constants.config";
import { getCashfree } from "../../utils/cashfree";
import { IndianRupee } from "lucide-react";
import axiosInstance from "../../api/axiosInstance";
import { paymentOnCashFree } from "../../api/pricing";
import { MakePaymentProcess } from "../pricing/MakePaymentProcess"
const DashboardStrip = ({ paymentData }) => {
    const userDetail = useSelector((state) => state.auth.userDetail);
    const [timeRemaining, setTimeRemaining] = useState({});
    const [InitializeCashfree, setInitializeCashfree] = useState(false);
    const router = useNavigate();
    const primaryThemeButtonStyle = {
      backgroundColor: "var(--bs-emphasis-color)",
      borderColor: "var(--bs-emphasis-color)",
      color: "var(--bs-body-bg)",
    };
    const doPayment = async (payId, paymentID, isRecurringPayment) => {
      const cashfree = await getCashfree();
      if (isRecurringPayment) {
        let checkoutOptions = {
          subsSessionId: payId,
          // redirectTarget: "_blank",
        };
        cashfree.subscriptionsCheckout(checkoutOptions).then((result) => {
          if (result.error) {
            // handleScrollToTop();
            // router("/txn/failure");
            setInitializeCashfree(false);
            // This will be true whenever user clicks on close icon inside the modal or any error happens during the payment
            console.log(
              "User has closed the popup or there is some payment error, Check for Payment Status",
            );
            console.log(result.error);
          }
          if (result.redirect) {
            setInitializeCashfree(false);
            // This will be true when the payment redirection page couldnt be opened in the same window
            // This is an exceptional case only when the page is opened inside an inAppBrowser
            // In this case the customer will be redirected to return url once payment is completed
            console.log("Payment will be redirected");
          }
          if (result.paymentDetails) {
            localStorage.setItem(
              "pid",
              window.paymentID ? window.paymentID : paymentID,
            );
            localStorage.removeItem("cz");
            // axiosInstance.post(`${V1_API_ORIGIN}/payments/${window.paymentID ? window.paymentID : paymentId}`, {
            //   payStatus: "success",
            // });
            setInitializeCashfree(false);
            // router("/txn/success");
            // router("/my-services");
            // window.location.reload();
            // handleScrollToTop();
            // This will be called whenever the payment is completed irrespective of transaction status
            console.log("Payment has been completed, Check for Payment Status");
            console.log(result.paymentDetails.paymentMessage);
          }
        });
      } else {
        let checkoutOptions = {
          paymentSessionId: payId,
          redirectTarget: "_modal",
        };
        cashfree.checkout(checkoutOptions).then((result) => {
          if (result.error) {
            // handleScrollToTop();
            router("/txn/failure");
            setInitializeCashfree(false);
            // This will be true whenever user clicks on close icon inside the modal or any error happens during the payment
            console.log(
              "User has closed the popup or there is some payment error, Check for Payment Status",
            );
            console.log(result.error);
          }
          if (result.redirect) {
            setInitializeCashfree(false);
            // This will be true when the payment redirection page couldnt be opened in the same window
            // This is an exceptional case only when the page is opened inside an inAppBrowser
            // In this case the customer will be redirected to return url once payment is completed
            console.log("Payment will be redirected");
          }
          if (result.paymentDetails) {
            localStorage.removeItem("cz");

            axiosInstance.post(`${V1_API_ORIGIN}/payments/${paymentID}`, {
              payStatus: "success",
            });
            setInitializeCashfree(false);
            // router("/txn/success");
            router("/my-services");
            window.location.reload();
            // handleScrollToTop();
            // This will be called whenever the payment is completed irrespective of transaction status
            console.log("Payment has been completed, Check for Payment Status");
            console.log(result.paymentDetails.paymentMessage);
          }
        });
      }
    };

    const handlePayment = (item) => {
      localStorage.setItem("pid", item.id);
      setInitializeCashfree(true);
      paymentOnCashFree(item.id, item.isRecurringPayment).then((response) => {
        if (response?.data?.status) {
          if (item.isRecurringPayment) {
            doPayment(
              response.data?.data?.subscription_session_id,
              item.id,
              item.isRecurringPayment,
            );
          } else {
            doPayment(response.data?.data?.payment_session_id, item.id);
          }
        }
      });
    };

    useEffect(() => {
      const calculateTimeRemaining = (expiryDate) => {
        const now = moment();
        const expiry = moment(expiryDate);

        if (expiry.isAfter(now)) {
          const duration = moment.duration(expiry.diff(now));
          const days = Math.floor(duration.asDays());
          const hours = duration.hours();
          const minutes = duration.minutes();
          const seconds = duration.seconds();

          setTimeRemaining({
            days,
            hours,
            minutes,
            seconds,
          });
        } else {
          setTimeRemaining("Expired");
        }
      };

      const activePayment = paymentData.find(
        (data) => data.payStatus === "processing" && data.expiryDate,
      );
      if (activePayment && activePayment.expiryDate) {
        calculateTimeRemaining(activePayment.expiryDate);
        const intervalId = setInterval(
          () => calculateTimeRemaining(activePayment.expiryDate),
          1000,
        );
        return () => clearInterval(intervalId);
      }
    }, [paymentData]);

    // Filter and map only the processing payment data
    return (
      <>
        {/* Condition 1: Payment is processing, digioDocSignStatus is success, and expiryDate is null */}
        {paymentData
          .filter(
            (data) =>
              (data.payStatus === "processing" ||
                data.payStatus === "failed" ||
                data.payStatus === "cancelled") &&
              data.digioDocSignStatus === "success" &&
              moment(data.digioValidTill).isAfter(moment()),
            // !data.subscriptionId
          )
          .map((data, index) => (
            <div key={`condition1-${index}`} className="col-12 col-md-12 py-2">
              {index == 0 ? (
                <p className="fst-italic my-1">Continue with...</p>
              ) : (
                ""
              )}
              <div className="rounded-3 text-center border p-2 bg-body">
                <div className="row g-2 align-items-center py-2">
                  <div className="col-md-3 mb-0">
                    {/* <h6 className="fw-bold">Package</h6> */}
                    {/* {data.cartItems?.map((item, idx) => (
                      <small
                        key={idx}
                        className="d-block"
                      >
                        <small>
                          <b>{item.name}</b> ({item.pacDuration} Months)
                        </small>
                      </small>
                    ))} */}
                    {data.paymentType !== "bundle" ? (
                      data.cartItems?.map((item, idx) => (
                        <p key={idx} className="mb-0">
                          <b>{item.name}</b> ({item.pacDuration}{" "}
                          {item.durationType ? item.durationType : "Months"})
                        </p>
                      ))
                    ) : (
                      <p className="mb-0">
                        {data.bundleName} ({data.cartItems[0].pacDuration}{" "}
                        {data.cartItems[0].durationType
                          ? data.cartItems[0].durationType
                          : "Months"}
                        )
                      </p>
                    )}
                  </div>
                  <div className="col-md-3 text-center">
                    <p className="mb-0">
                      <i className="fa fa-circle-check text-success"></i>{" "}
                      Agreement <small className="text-muted"> (Signed)</small>
                    </p>
                    {/* <p className="mb-0"><small className=""><i className="fa fa-triangle-exclamation text-warning"></i> Payment <small className="text-muted"> (Pending)</small></small></p> */}
                  </div>

                  <div className="col-md-3">
                    <h5 className="fw-bold mb-0">
                      <IndianRupee size={18} />
                      {data.pacAmount.toLocaleString("en-US")}
                      <small className="fw-normal">
                        <small> + 18% GST</small>
                      </small>
                    </h5>
                  </div>
                  <div className="col-md-3">
                    <button
                      className="btn  w-50"
                      style={primaryThemeButtonStyle}
                      onClick={() => {
                        // localStorage.setItem("pz", JSON.stringify(data));
                        // handleScrollToTop();
                        // router(
                        //   // `/make-payment?amount=${
                        //   //   paymentData && paymentData[0]?.paidAmount
                        //   // }`
                        //   "/make-payment"
                        // );
                        handlePayment(data);
                      }}
                    >
                      Pay Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}

        {/* Condition 2: Payment has an expiry date that is still valid */}
        {paymentData
          .filter(
            (data) =>
              data.expiryDate &&
              moment(data.expiryDate).isAfter(moment()) &&
              data.payStatus === "processing" &&
              (data.digioDocSignStatus == "cancel" ||
                !data.digioDocSignStatus) &&
              (!data.digioValidTill ||
                moment(data.digioValidTill).isAfter(moment())) &&
              !(
                moment(data.expiryDate).isBefore(moment()) && // expiry already passed
                data.digioValidTill &&
                moment(data.digioValidTill).isAfter(moment(data.expiryDate)) // digio > expiry
              ),
          )
          .map((data, index) => (
            <div key={`condition2-${index}`} className="col-12 py-2">
              {index == 0 ? (
                <p className="fw-bold text-capitalize my-1">
                  Special Offer Approved For You
                </p>
              ) : (
                ""
              )}
              <div className="rounded-3 text-center bg-success bg-opacity-10 border border-success p-1">
                <div className="row align-items-center">
                  <div className="col-md-3">
                    <h6 className="fw-bold mb-0">
                      <small>Limited Time Offer</small>
                    </h6>
                    <div className="">
                      <p className="mb-0">ends in </p>
                      <div className="badge bg-danger text-white rounded-3 justify-content-center">
                        <span
                          className={`${timeRemaining.days > 0 ? "" : "d-none"
                            } mx-1`}
                        >
                          {timeRemaining.days}
                          {" : "}
                          <small>d</small>
                        </span>

                        <span
                          className={`${timeRemaining.hours > 0 ? "" : "d-none"
                            } mx-1`}
                        >
                          {timeRemaining.hours}
                          {" : "}
                          <small>h</small>
                        </span>

                        <span
                          className={`${timeRemaining.minutes > 0 ? "" : "d-none"
                            } mx-1`}
                        >
                          {timeRemaining.minutes}
                          {" : "}
                          <small>m</small>
                        </span>
                        <span className="mx-1">
                          {timeRemaining.seconds}
                          {" : "}
                          <small>s</small>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    {/* <h5 className="fw-bold">{data.paymentType === "bundle"?"Bundle":"Package"}</h5> */}
                    {data.paymentType !== "bundle" ? (
                      data.cartItems?.map((item, idx) => (
                        <small
                          key={idx}
                          className="rounded-3 bg-success bg-opacity-10  d-inline-block"
                        >
                          <small>
                            {item.name} ({item.pacDuration} Months)
                          </small>
                        </small>
                      ))
                    ) : (
                      <small className="rounded-3 bg-success bg-opacity-10  d-inline-block">
                        {data.bundleName} ({data.cartItems[0].pacDuration}{" "}
                        Months)
                      </small>
                    )}
                  </div>
                  <div className="col-md-4">
                    <h5 className="mb-0">
                      <>
                        <s className={data.discount > 0 ? "" : "d-none"}>
                          {" "}
                          <IndianRupee size={18} />
                          {data.actualAmount.toLocaleString("en-IN")}
                        </s>{" "}
                        <b>
                          <IndianRupee size={18} />
                          {data.pacAmount.toLocaleString("en-IN")}
                        </b>
                        <small className="fw-normal"> + 18% GST</small>
                      </>
                      {/*<IndianRupee size={18} />*/}
                      {/*{data.pacAmount.toLocaleString("en-US")}*/}
                    </h5>
                  </div>
                  <div className="col-md-2 mt-2">
                    <MakePaymentProcess
                      planData={{
                        [data.id]: {
                          id: data.id,
                          orderItems: data.cartItems,
                          name:
                            data.paymentType == "bundle"
                              ? data.bundleName
                              : data.cartItems?.[0]?.name,
                          description: data.cartItems?.[0]?.description,
                          digioDescription:
                            data.cartItems?.[0]?.digioDescription,
                          firebaseName: data.cartItems?.[0]?.firebaseName,
                          actualPrice: data.actualAmount,
                          discountPrice: data.discount,
                          pacId: data.cartItems?.[0]?.pacId,
                          planDuration: data.cartItems?.[0]?.pacDuration,
                          rpfType: data.cartItems?.[0]?.rpfType,
                          durationType: data.cartItems?.[0]?.durationType,
                        },
                      }}
                      componentKey={data.id}
                      total={data.pacAmount}
                      gst={data.igst}
                      grandTotal={data.paidAmount}
                      isPaymentRequest={true}
                      paymentId={data.id}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
      </>
    );
  };

export default function Header2() {
  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state.auth.userDetail);
  const { theme } = useTheme();
  const isDark = theme === "dark";
  const uid = localStorage.getItem("uid");
  const [hasPayment, setHasPayment] = useState([{ cartItems: [] }]);
  const logout = () => {
    dispatch(logoutUser());
    setTimeout(() => {
      window.location.href = "/login";
    }, 2000); // 2 seconds
  };

  useEffect(() => {
    axiosInstance
      .get(`${V1_API_ORIGIN}/payments?userId=${uid}&perPage=10&currentPage=1`)
      .then((response) => {
        setHasPayment(response.data.data.dataList);
      });

  }, [])
  return (
    <>
      <section
        className={`shadow-sm sticky-top ${isDark ? "" : "bg-body"}`}
        style={
          isDark
            ? {
              backgroundColor: "#0A0A0A",
              borderBottom: "1px solid rgba(148, 163, 184, 0.12)",
              backdropFilter: "blur(14px)",
            }
            : undefined
        }
      >
        <div
          className="container"
          style={isDark ? { backgroundColor: "transparent" } : undefined}
        >
          <div
            className="row align-items-center justify-content-between p-2"
            style={isDark ? { backgroundColor: "transparent" } : undefined}
          >
            <div className="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-5 order-lg-1 order-sm-1 order-1 px-0">
              <div className="d-flex align-items-center">
                <a className="ms-1 navbar-brand" href="./">
                  <img
                    loading="lazy"
                    className="mb-1 img-fluid"
                    src={
                      theme === "dark"
                        ? "/assets/img/25.svg"
                        : "/assets/ep-imgs/ep-advisor-logo.svg"
                    }
                    alt="EP-Investment-Advisor"
                  />
                </a>
              </div>
            </div>

            <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12 order-lg-2 order-sm-3 order-3">
              <nav className="navbar navbar-expand-lg py-0 d-none">
                <div className="container">
                  <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                      <li className="nav-item">
                        <a className="menu-visit nav-link active" aria-current="page" href="/dashboard">
                          <small>Dashboard</small>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="menu-visit nav-link active" aria-current="page" href="/portfolio">
                          <small>Equity</small>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="menu-visit nav-link active" aria-current="page" href="/etf">
                          <small>ETFs</small>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="menu-visit nav-link active" aria-current="page" href="/mf">
                          <small>Mutual Funds</small>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="menu-visit nav-link active" aria-current="page" href="/multibagger">
                          <small>Multibaggers</small>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="menu-visit nav-link active" aria-current="page" href="/ipo">
                          <small>IPO</small>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>

            <div className="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-7 order-lg-3 order-sm-2 order-2 text-end">
              <div className="d-flex gap-2 justify-content-end align-items-center">
                <AccessibilityMenu />
                {userDetail?.isActive &&
                  <nav className="dropdown text-end" aria-label="Account navigation">
                    <button
                      type="button"
                      className="ms-2 fw-semibold btn btn-success text-uppercase rounded-circle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      aria-haspopup="menu"
                      aria-label="Open profile menu"
                    >
                      {userDetail && userDetail?.firstName?.hasOwnProperty(0) ? userDetail?.firstName[0] : ""}
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end text-small"
                    >
                      <li >
                        <a className="dropdown-item" aria-current="page" href="/pricing">
                          <small>Pricing</small>
                        </a>
                      </li>
                      <li >
                        <a className="dropdown-item" aria-current="page" href="/profile">
                          <small>My Profile</small>
                        </a>
                      </li>
                      <li>
                        <button type="button" className="dropdown-item" onClick={logout} >
                          Sign out
                        </button>
                      </li>
                    </ul>
                  </nav>
                }
              </div>
            </div>
            {DashboardStrip}
          </div>
        </div>
      </section >
      <section className="bg-success bg-opacity-10">
        <div className="container">
          <div className="row justify-content-center">
            {hasPayment?.length > 0 && (
              <DashboardStrip paymentData={hasPayment} />
            )}
          </div>
        </div>
      </section>
    </>
  );
}
